import React from "react"
import Navigation from "../Navigation/Navigation"
import s from "./Sidebar.less"

const Sidebar: React.FC = () => {
  return (
    <div className={s.root}>
      <div className={s.sidebar}>
        <Navigation />
      </div>
    </div>
  )
}

export default Sidebar
